// extracted by mini-css-extract-plugin
export default {"wrap":"Chat_wrap__R+qp6","messageList":"Chat_messageList__4E7QT","smooth-appear":"Chat_smooth-appear__1YIqu","emptyMessages":"Chat_emptyMessages__RfKne"};